import menu from './menu'

export default {
  menu: { schema: menu },
}
